import styled from 'styled-components'

import { media, COLORS, typeScale, hoverSelector } from '../../styles'
import Button from '../Button'
import Icon from '../Icon'
import Like from '../Like'
import ObfuscatedNavLink from '../ObfuscatedNavLink'

const Styled = styled.div`
  align-items: center;
  background: none;
  display: flex;
  justify-content: ${({ displayMenuEdition }) =>
    displayMenuEdition ? 'space-between' : 'center'};
  padding: 1.2rem 2.4rem;
  ${media.medium`
    padding: 1.2rem 3.2rem;
  `}
`
Styled.buttons = styled.div``
Styled.addOrChoose = styled(Button)`
  display: inline-block;
  margin: 0 1.6rem 0 0;
  border: 0;
  color: ${COLORS.white};
  transition: background-color 0.2s ease-in-out;
  background-color: ${COLORS.primary};
  line-height: normal;
  padding: 0.8rem 1.2rem;
`
Styled.remove = styled(Styled.addOrChoose)`
  background-color: ${COLORS.kale};
`
Styled.icons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
Styled.share = styled.div`
  ${typeScale('caption', { lineHeight: '3.2rem' })};
  position: relative;
  margin: 0;
  text-transform: uppercase;
  font-weight: bold;
  color: ${COLORS.primary};
  height: 2.8rem;
`
Styled.shareButton = styled.div`
  margin: 0;
  padding: 0.2rem;
  height: 2.8rem;
  background: none;
  border: 0;
  cursor: ${({ isLoading }) => (isLoading ? 'default' : 'pointer')};
  display: inline-block;
  border-radius: 9999px;

  & * {
    transition: fill 0.2s ease-in-out;
  }
  ${({ isLoading }) =>
    isLoading
      ? ''
      : hoverSelector('*')`
    fill: ${COLORS.primary};
  `}
`
Styled.shareIcon = styled(Icon)`
  width: 2.4rem;
  height: 2.4rem;
  display: block;
`
Styled.print = styled(ObfuscatedNavLink)`
  margin: 0 0 0 0.8rem;
  background: none;
  border: 0;
  cursor: ${({ isLoading }) => (isLoading ? 'default' : 'pointer')};
  display: inline-block;
  padding: 0.2rem;
  height: 2.8rem;
  border-radius: 9999px;

  & * {
    transition: fill 0.2s ease-in-out;
  }
  ${({ isLoading }) =>
    isLoading
      ? ''
      : hoverSelector('*')`
    fill: ${COLORS.primary};
  `}
`
Styled.like = styled(Like)`
  margin: 0 0 0 0.8rem;
  padding-left: 0;
  padding-right: 0;
  border-radius: 9999px;
`

export default Styled
